<dx-popup
  title="Réceptions et sorties en cours"
  (onHidden)="onClose()"
  [visible]="displayDialog()"
  [width]="1000"
  [height]="800"
  [showCloseButton]="true"
  [resizeEnabled]="true">

  <div class="conflit-grid-container">
    <dx-data-grid
      id="conflit-grid"
      [dataSource]="conflitList()"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [showRowLines]="true"
      height="100%">

      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxo-paging [pageSize]="25"></dxo-paging>
      <dxo-pager
        [visible]="true"
        [showPageSizeSelector]="true"
        [allowedPageSizes]="[25, 50, 100, 200]"
        [showNavigationButtons]="true"
        [showInfo]="true"
        infoText="{2} conflit(s)">
      </dxo-pager>

      <dxi-column dataField="type" caption="Type" [cellTemplate]="'typeTemplate'">
        <dxo-lookup [dataSource]="typeEnum" valueExpr="value" displayExpr="text"></dxo-lookup>
      </dxi-column>

      <dxi-column dataField="libelle" caption="Libellé" [allowHeaderFiltering]="false"></dxi-column>

      <dxi-column dataField="code" caption="Code / Numéro"></dxi-column>

      <div *dxTemplate="let cell of 'typeTemplate'">
        {{ getConflitTypeLabel(cell.value) }}
      </div>
    </dx-data-grid>
  </div>
</dx-popup>
